import { loadStripe } from "@stripe/stripe-js";

// Publishable key comes from the backend so it follows key rotation in Platform Admin → APIs.
export const stripePromise = fetch(`${process.env.REACT_APP_BACKEND_URL}/api/payments/config`)
  .then((r) => r.json())
  .then((d) => (d.publishable_key ? loadStripe(d.publishable_key) : null))
  .catch(() => null);
